import { 
    gql, 
    useQuery 
} from "@apollo/client";
import { FindBankPreferenceByUserIdQueryQuery, FindBankPreferenceByUserIdQueryQueryVariables } from "../../schemaTypes";
import * as React from "react";
import { newBankPreferenceSubscription } from "../MyBankPreference";

export const findBankPreferenceByUserIdQuery = gql`
  query FindBankPreferenceByUserIdQuery(
        $id: String!
    ) {
    findBankPreferenceByUserId(
        id: $id
    ) {
      id
      bank {
        id
        bank
        bankCode
        pictureUrl
      }
      accountNo
      createdAt
      updatedAt
    }
  }
`;

export function useFindBankPreferenceByUserId({id}:{id:string}) {
  const { data, loading, subscribeToMore } = useQuery<
  FindBankPreferenceByUserIdQueryQuery,
  FindBankPreferenceByUserIdQueryQueryVariables
  >(
    findBankPreferenceByUserIdQuery, {
      variables: { id }
    }
  );

  React.useEffect(() => {
    if (!subscribeToMore) return;
    const unsubscribe = subscribeToMore({
      document: newBankPreferenceSubscription,
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) return prev;
        return {
          ...prev,
          findBankPreferenceByUserId: [
            ...(prev.findBankPreferenceByUserId ?? []),
            (subscriptionData.data as any).newBankPreference
          ]
        };
      }
    });
    return () => unsubscribe();
  }, [subscribeToMore]);

  return {
    findBankPreferenceByUserId: data?.findBankPreferenceByUserId ?? [],
    loading
  };
}